import type { HeaderProps } from '@loomstateorg/shared-frontend/components/commercetools-ui/organisms/header/types';

/**
 * Brand-specific classes for the header (navigation, drawers, account/cart popovers, search).
 * Undefined fields resolve to the Cava defaults inside the header components.
 * The `headerCms` tastic spreads its brand look into `Header`.
 */
export type HeaderLook = Pick<
  HeaderProps,
  | 'backgroundClassName'
  | 'topRowClassName'
  | 'mobileDrawerClassName'
  | 'overlayClassName'
  | 'panelClassName'
  | 'accountPanelPositionClassName'
  | 'accountDropdownLook'
  | 'rowSurfaceClassName'
  | 'navLinkTypographyClassName'
  | 'searchDrawerClassName'
  | 'searchSubmitButtonClassName'
  | 'searchIconFocusedClassName'
  | 'imageApi'
>;

export const CAVA_HEADER_LOOK: HeaderLook = {};

export const PANDA_HEADER_LOOK: HeaderLook = {
  backgroundClassName: 'bg-white',
  mobileDrawerClassName: 'w-4/5 border border-neutral-400 bg-neutral-100',
  panelClassName: 'bg-white',
  accountDropdownLook: {
    className: 'flex w-160 flex-col',
    rowClassName:
      'w-full rounded-md border-0 px-14 py-10 outline-none transition-colors hover:bg-neutral-150 active:border-0 active:bg-neutral-200 focus-within:ring-2 focus-within:ring-primary-regular/25',
    rowButtonClassName:
      'flex min-h-[30px] w-full items-center border-0 bg-transparent p-0 text-left shadow-none outline-none ring-0 [-webkit-tap-highlight-color:transparent] hover:bg-transparent focus:bg-transparent focus:outline-none focus:ring-0 active:border-0 focus-visible:outline-none',
    logoutTriggerClassName:
      'flex min-h-[54px] w-full items-center justify-start border-0 bg-transparent text-left shadow-none outline-none ring-0 [-webkit-tap-highlight-color:transparent] focus:outline-none focus:ring-0 active:border-0 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-regular/25',
  },
  rowSurfaceClassName:
    'w-full rounded-md border-0 px-14 py-10 outline-none ring-0 transition-colors hover:bg-neutral-200 active:border-0 active:bg-neutral-200 focus-within:ring-0',
  navLinkTypographyClassName: 'text-16 2xl:text-18',
  searchDrawerClassName: 'bg-white',
  imageApi: 'layout',
};

export const LOOM_HEADER_LOOK: HeaderLook = {
  topRowClassName:
    'mb-10 flex w-full items-stretch justify-between px-16 md:px-24 lg:mb-0 lg:items-center lg:px-20 xl:px-48',
  mobileDrawerClassName: 'w-4/5 border border-neutral-400 bg-neutral-100',
  accountPanelPositionClassName: 'left-28',
  accountDropdownLook: {
    rowClassName:
      'w-full rounded-md border-0 px-14 py-10 outline-none ring-0 transition-colors hover:bg-neutral-150 active:border-0 active:bg-neutral-200 focus-within:ring-0',
  },
  rowSurfaceClassName:
    'w-full rounded-md border-0 px-14 py-10 outline-none ring-0 transition-colors hover:bg-neutral-200 active:border-0 active:bg-neutral-200 focus-within:ring-0',
  navLinkTypographyClassName: 'text-16 2xl:text-18',
  searchSubmitButtonClassName: 'border border-primary-regular',
  searchIconFocusedClassName: 'fill-primary-regular',
};
